import styled from "styled-components";

const CompletedNavWrapper = styled.section`
  box-sizing: border-box;
  width: 100%;
  height: 5.6rem;
  min-height: 5.6rem;
  display: flex;
  justify-content: center;
`;

export default CompletedNavWrapper;
